'use client';

/**
 * POST `/auth/session/none`, which writes the "confirmed logged out" (`n:1`)
 * marker into the `__session` cookie (unless it already holds a real session).
 * Returns whether the request succeeded.
 *
 * Keeping the cookie PRESENT as `n:1` for a guest is what lets the server skip
 * the optimistic-refresh redirect that would otherwise tear down an intercepted
 * modal. Symmetric with {@link postSessionCookie} (the signed-in counterpart).
 */
export async function markSessionNone(): Promise<boolean> {
  const response = await fetch('/auth/session/none', {
    method: 'POST',
    credentials: 'include',
  });
  return response.ok;
}
